<template>
  <div class="main">
    <el-button size="small" class="record-btn" icon="el-icon-document" @click="showRecord">
      批量下单记录
    </el-button>
    <div>
      <el-steps :active="step" align-center :class="{ 'steps-done': step >= 2 }">
        <el-step title="下载模板并上传文件" description="" />
        <el-step title="下单导入处理" description="" />
        <el-step title="完成下单" description="" />
      </el-steps>
    </div>

    <div v-show="step==0" class="upload-container">
      <el-upload
        class="upload-demo"
        :action="'/api/file/uploader/temporaryFile' | toUrl()"
        :headers="{ Authorization: token}"
        :limit="1"
        :disabled="previewLoading || isImporting"
        :before-upload="beforeUpload"
        :on-success="handleSuccess"
        :on-error="handleUploadError"
        :file-list="fileList"
        accept=".xls,.xlsx"
      >
        <img src="../../assets/img/manage/upload.png" style="width: 61px;height: 78x;">
      </el-upload>
      <p class="upload-title">
        点击上传填写好的订单表
      </p>
      <p class="tip">
        文件后缀名仅支持 xls 或 xlsx，<br>
        大小不超过 50MB，最多支持导入 1000 条数据
      </p>
      <el-button size="small" icon="el-icon-download" class="download-btn" @click="templateDownload">
        FBA 批量下单模板下载
      </el-button>
    </div>
    <div v-show="step==1" class="step1-container">
      <div v-if="step1Mode !== 'fix'" class="step1-status">
        <img src="../../assets/img/manage/loading.gif" style="width: 61px;height: 78x;">
        <div class="success-box">
          <img src="../../assets/img/manage/success.png" style="width: 70px;height: 70x;">
          <span class="success-tip">订单上传成功，正在处理中</span>
        </div>
        <p class="tip">
          下单数据处理需要一定时间，您可稍后回来在右上角 “<span class="link">批量下单记录</span>” 中查看下单结果
        </p>
      </div>
      <div v-else class="fix-container">
        <div class="fix-title">导入失败，请按提示修改后重新导入。</div>
        <div class="fix-desc">
          <div class="fix-desc-line">地址类型为“私人地址”时：地址字段必填，仓库编码必须为空。</div>
          <div class="fix-desc-line">地址类型不为“私人地址”时：地址字段必须全部为空，仓库编码必填。</div>
        </div>
        <div class="fix-table">
          <el-table :data="addressFixRows" height="360" border>
            <el-table-column prop="_index" label="序号" width="70" />
            <el-table-column prop="refNo" label="参考号" width="160" />
            <el-table-column prop="addressType" label="地址类型" width="130">
              <template slot-scope="scope">
                <el-input v-model="scope.row.addressType" size="small" />
              </template>
            </el-table-column>
            <el-table-column prop="storeCode" label="仓库编码" width="120">
              <template slot-scope="scope">
                <el-input v-model="scope.row.storeCode" size="small" />
              </template>
            </el-table-column>
            <el-table-column prop="companyName" label="公司名称" width="180">
              <template slot-scope="scope">
                <el-input v-model="scope.row.companyName" size="small" />
              </template>
            </el-table-column>
            <el-table-column prop="name" label="联系人" width="120">
              <template slot-scope="scope">
                <el-input v-model="scope.row.name" size="small" />
              </template>
            </el-table-column>
            <el-table-column prop="tel" label="联系电话" width="150">
              <template slot-scope="scope">
                <el-input v-model="scope.row.tel" size="small" />
              </template>
            </el-table-column>
            <el-table-column prop="countryCode" label="国家编码" width="110">
              <template slot-scope="scope">
                <el-input v-model="scope.row.countryCode" size="small" />
              </template>
            </el-table-column>
            <el-table-column prop="provinceName" label="省/州" width="120">
              <template slot-scope="scope">
                <el-input v-model="scope.row.provinceName" size="small" />
              </template>
            </el-table-column>
            <el-table-column prop="cityName" label="城市" width="120">
              <template slot-scope="scope">
                <el-input v-model="scope.row.cityName" size="small" />
              </template>
            </el-table-column>
            <el-table-column prop="zipCode" label="邮编" width="110">
              <template slot-scope="scope">
                <el-input v-model="scope.row.zipCode" size="small" />
              </template>
            </el-table-column>
            <el-table-column prop="address" label="详细地址" min-width="260">
              <template slot-scope="scope">
                <el-input v-model="scope.row.address" size="small" />
              </template>
            </el-table-column>
            <el-table-column label="操作" fixed="right" width="110">
              <template slot-scope="scope">
                <el-button type="primary" size="mini" @click="confirmRef(scope.row)">确定</el-button>
              </template>
            </el-table-column>
          </el-table>
        </div>
        <div class="fix-footer">
          <el-button size="small" @click="cancelFix">上一步</el-button>
          <el-button size="small" type="primary" :loading="btnLoading" :disabled="btnLoading || isImporting" @click="submitAfterFix">确定</el-button>
        </div>
      </div>
    </div>
    <div v-show="step==2" class="result-container">
      <div class="file-table">
        <table class="table">
          <tr>
            <td>上传文件名</td>
            <td>总订单数</td>
            <td>上传成功订单数</td>
            <td>上传失败订单数</td>
            <td>导出上传失败订单</td>
          </tr>
          <tr>
            <td>{{ result.fileName }}</td>
            <td>{{ result.fnum+result.snum }}</td>
            <td>
              {{ result.snum }}
            </td>
            <td>
              {{ result.fnum }}
              <span v-if="result.fnum>0" style="color:#3370FF;cursor: pointer;" @click="()=>{ isShowFailResult = true}">查看</span>
            </td>
            <td style="color: #3370FF;cursor: pointer;;" @click="exportResult(result)">
              导出
            </td>
          </tr>
        </table>
      </div>
    </div>
    <div v-show="step==3" class="result-container">
      <div class="file-table">
        <table class="table">
          <tr>
            <td>文件上传失败</td>
          </tr>
          <tr>
            <td>{{ failReason }}</td>
          </tr>
        </table>
      </div>
    </div>
    <RecordDialog :value="isShowRecord" @close="()=>{ isShowRecord = false}">
      <template v-slot:title>
        <div>批量下单记录</div>
      </template>
      <template v-slot:body>
        <div class="record-title">近一个月的下单记录</div>
        <div class="file-table">
          <table class="table">
            <thead>
              <tr>
                <td>上传文件名</td>
                <td>操作人</td>
                <td>导入（总计/成功/失败）</td>
                <td>状态</td>
                <td>上传时间</td>
                <td>操作</td>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(item,index) in recordList" :key="index" style="">

                <td>{{ item.fileName }}</td>
                <td>{{ item.creatorName }}</td>
                <td>{{ item.totalNum }} / <span class="green">{{ item.successNum }}</span> / <span class="red">{{ item.failNum }}</span></td>
                <td>
                  <span v-if="item.status==1" class="green">成功</span>
                  <span v-if="item.status!=1" class="red">失败</span>
                </td>
                <td>{{ xms.toDate(item.creatorTime) }}
                </td>
                <td style="color: #3370FF;cursor: pointer;;" @click="exportResult(item)">
                  导出
                </td>
              </tr>
            </tbody>

          </table>
        </div>
      </template>
      <template v-slot:footer />
    </RecordDialog>
    <RecordDialog :value="isShowFailResult" @close="()=>{ isShowFailResult = false}">
      <template v-slot:title>
        <div>查看失败原因</div>
      </template>
      <template v-slot:body>
        <div class="record-title">导入失败，请按提示修改后重新导入。</div>
        <div class="file-table">
          <table class="table">
            <thead style="width: 100%;">
              <tr>
                <td>错误位置</td>
                <td>错误原因</td>
              </tr>
            </thead>
            <tbody style="width: 100%;">
              <tr v-for="(item,index) in result.failResult" :key="index" style="width: 100%;">

                <td>{{ item.failName }}</td>
                <td>{{ item.reason }}</td>
              </tr>
            </tbody>

          </table>
        </div>
      </template>
      <template v-slot:footer />
    </RecordDialog>
  </div>
</template>

<script>
import {
  getCookie
} from '@/utils/cookiejs'
import RecordDialog from '@/components/Dialog/Dialog.vue'
import request from '@/utils/request'
export default {
  components: {
    // 组件的引用
    RecordDialog
  },
  data() {
    return {
      fileList: [],
      step: 0,
      token: '',
      fileName: '',
      list: [],
      result: {},
      isShowRecord: false,
      isShowFailResult: false,
      recordList: [],
      isImportFailed: false,
      failReason: '',
      step1Mode: 'validating', // validating | fix | importing
      btnLoading: false,
      previewLoading: false,
      isImporting: false,
      addressFixRows: []
    }
  },
  created() {
    this.token = getCookie('token')
  },
  methods: {
    showRecord() {
      this.isShowRecord = true
      request({
        url: `/api/webapi/order/GetImportRecords`,
        method: 'GET',
        headers: {
          Authorization: this.token
        }
      }).then((res) => {
        this.recordList = res.data
      })
    },
    beforeUpload(file) {
      if (this.previewLoading || this.isImporting) {
        this.$message.warning('导入处理中，请勿重复上传')
        return false
      }
      if (file.size > 50 * 1024 * 1024) { // 10MB 大小验证
        this.$message.error('文件大小不能超过 50MB')
        return false
      }
      return true // 可在此处添加实际上传逻辑（如调用接口）
    },
    handleUploadError() {
      this.previewLoading = false
      this.$message.error('文件上传失败，请重试')
    },
    handleSuccess(res, file, fileList) {
      if (this.previewLoading || this.isImporting) {
        return
      }
      if (res.code === 200) {
        this.previewLoading = true
        this.fileName = res.data.name
        this.step = 1
        this.step1Mode = 'validating'
        request({
          url: `/api/shipping/fbaOrder/importPreview`,
          method: 'GET',
          data: {
            fileName: this.fileName
          },
          headers: {
            Authorization: this.token
          }
        }).then((res) => {
          this.list = (res && res.data && res.data.dataRow) ? res.data.dataRow : []
          this.list.forEach(item => {
            item.fileName = file.name
          })

          const addressFixRows = this.buildAddressFixRows(this.list)
          if (addressFixRows.length) {
            this.addressFixRows = addressFixRows
            this.step1Mode = 'fix'
            return
          }

          this.startImportData(file.name)
        }).catch(() => {
          this.$message.error('导入预览失败，请重试')
          this.step = 0
        }).finally(() => {
          this.previewLoading = false
        })
      } else {
        this.$message({
          message: res.msg,
          type: 'error',
          duration: 1000
        })
      }
    },
    exportResult(item) {
      request({
        url: `/api/webapi/order/ExportImportDetails`,
        method: 'GET',
        data: {
          importNo: item.importNo
        },
        headers: {
          Authorization: this.token
        }
      }).then((res) => {
        this.xms.downloadFile(res.data.url)
      })
    },
    templateDownload() {
      request({
        url: `/api/shipping/fbaOrder/CustomerTemplateDownload`,
        method: 'GET',
        headers: {
          Authorization: this.token
        }
      }).then((res) => {
        this.xms.downloadFile(res.data.url)
      })
    },
    normalizeText(v) {
      return (v === null || v === undefined) ? '' : String(v).trim()
    },
    isPrivateAddressType(addressType) {
      return this.normalizeText(addressType) === '私人地址'
    },
    getAddressRuleError(row) {
      const addressType = this.normalizeText(row.addressType)
      const storeCode = this.normalizeText(row.storeCode)
      const addrFields = {
        companyName: this.normalizeText(row.companyName),
        name: this.normalizeText(row.name),
        tel: this.normalizeText(row.tel),
        countryCode: this.normalizeText(row.countryCode),
        provinceName: this.normalizeText(row.provinceName),
        cityName: this.normalizeText(row.cityName),
        zipCode: this.normalizeText(row.zipCode),
        address: this.normalizeText(row.address)
      }
      const allAddressEmpty = Object.keys(addrFields).every(k => !addrFields[k])
      const anyAddressEmpty = Object.keys(addrFields).some(k => !addrFields[k])

      if (!addressType) return '地址类型不能为空'

      if (this.isPrivateAddressType(addressType)) {
        if (anyAddressEmpty) return '私人地址时地址字段不能为空'
        if (storeCode) return '私人地址时仓库编码必须为空'
        return ''
      }

      if (!allAddressEmpty) return '非私人地址时地址字段必须全部为空'
      if (!storeCode) return '非私人地址时仓库编码不能为空'
      return ''
    },
    buildAddressFixRows(list) {
      const mapByRef = new Map()
      ;(list || []).forEach((row, idx) => {
        const refNo = this.normalizeText(row.refNo)
        if (!refNo) return
        const reason = this.getAddressRuleError(row)
        if (!reason) return
        if (!mapByRef.has(refNo)) {
          mapByRef.set(refNo, {
            _index: mapByRef.size + 1,
            refNo,
            addressType: row.addressType,
            storeCode: row.storeCode,
            companyName: row.companyName,
            name: row.name,
            tel: row.tel,
            countryCode: row.countryCode,
            provinceName: row.provinceName,
            cityName: row.cityName,
            zipCode: row.zipCode,
            address: row.address,
            _reason: reason,
            _srcIndex: idx
          })
        }
      })
      return Array.from(mapByRef.values())
    },
    applyFixToAllRowsByRef(fixRow) {
      const refNo = this.normalizeText(fixRow.refNo)
      if (!refNo) return
      const keys = ['addressType', 'storeCode', 'companyName', 'name', 'tel', 'countryCode', 'provinceName', 'cityName', 'zipCode', 'address']
      this.list.forEach((row) => {
        if (this.normalizeText(row.refNo) !== refNo) return
        keys.forEach(k => {
          row[k] = fixRow[k]
        })
      })
    },
    confirmRef(fixRow) {
      this.applyFixToAllRowsByRef(fixRow)
      this.$message.success('已同步更新该参考号的所有数据')
    },
    submitAfterFix() {
      if (this.btnLoading || this.isImporting) {
        return
      }
      // 先把当前表格所有行都同步回原始 list（避免用户只改了没点每行确定）
      (this.addressFixRows || []).forEach(r => this.applyFixToAllRowsByRef(r))

      const stillBad = this.buildAddressFixRows(this.list)
      if (stillBad.length) {
        this.addressFixRows = stillBad
        this.$message.error('地址信息有误，请再次确认。')
        return
      }

      this.startImportData((this.addressFixRows[0] && this.addressFixRows[0].fileName) || (this.list[0] && this.list[0].fileName) || '')
    },
    cancelFix() {
      this.step = 0
      this.step1Mode = 'validating'
      this.previewLoading = false
      this.isImporting = false
      this.btnLoading = false
      this.addressFixRows = []
      this.fileList = []
      this.fileName = ''
      this.list = []
    },
    startImportData(displayFileName) {
      if (this.isImporting) {
        return
      }
      this.isImporting = true
      this.step1Mode = 'importing'
      this.submitImportData(displayFileName)
    },
    submitImportData(displayFileName) {
      this.btnLoading = true
      request({
        url: `/api/shipping/fbaOrder/importData`,
        method: 'POST',
        data: this.list,
        headers: {
          Authorization: this.token
        }
      }).then((res) => {
        if (res.code === 200) {
          this.result = res.data
          this.result.fileName = displayFileName || (this.list[0] && this.list[0].fileName) || ''
          this.step = 2
        }
      }).catch((res) => {
        this.step = 3
        this.failReason = res
      }).finally(() => {
        this.btnLoading = false
        this.isImporting = false
      })
    }
  }
}
</script>

<style scoped lang="scss">
	.main {
		padding-top: 40px;
		background-color: #ffffff;
		padding-bottom: 80px;
	}

	.upload-container {
		text-align: center;
		padding: 50px 0;
		width: 60%;
		margin-top: 50px;
		margin-left: 20%;
		border: 2px dashed #EBEBED;
		border-radius: 20px;
		background-color: #F8FBFC;
		height: 280px;
	}

  /* step==1 专用容器：修正表格需要更宽展示 */
  .step1-container {
    width: 92%;
    margin-left: 4%;
    margin-top: 28px;
  }

  .step1-status {
    text-align: center;
    padding: 50px 0;
    border: 2px dashed #EBEBED;
    border-radius: 20px;
    background-color: #F8FBFC;
    height: 280px;
  }

	.result-container {
		text-align: center;
		padding: 50px 0;
	}

	.upload-title {
		color: #172031;
		font-size: 16px;
		font-weight: 800;
	}

	.tip {
		color: #808597;
		font-size: 14px;
	}

	.download-btn {
		background: #F8FBFC;
		border-radius: 34px 34px 34px 34px;
		border: NaNpx solid #DFE9FF;
		color: #1172FC;
		padding: 15px;
		border-color: #1172FC;
		margin-top: 30px;
	}

	.record-btn {
		background: #FFFFFF;
		border-radius: 4px 4px 4px 4px;
		border: NaNpx solid #3370FF;
		color: #1172FC;
		border-color: #1172FC;
		margin-left: 85%;
	}

	.success-box {
		display: flex;
		align-items: center;
		height: 70px;
		justify-content: center
	}

	.link {
		color: #3370FF;
	}

	.success-tip {
		color: #272727;
		font-size: 18px;
		margin-left: 5px;
	}

  .fix-container {
    width: 100%;
    text-align: left;
    padding: 8px 0 0 0;
  }

  .fix-title {
    font-size: 16px;
    font-weight: 600;
    color: #172031;
    margin: 8px 0 10px 0;
    text-align: left;
  }

  .fix-desc {
    color: #808597;
    font-size: 13px;
    line-height: 1.6;
    margin-bottom: 14px;
  }

  .fix-desc-line {
    margin: 2px 0;
  }

  .fix-table {
    width: 100%;
  }

  .fix-footer {
    display: flex;
    justify-content: flex-end;
    gap: 12px;
    margin-top: 16px;
  }

  /* 第三步标题与线条改为蓝色（满足“③完成下单 和线条修改为蓝色”） */
  ::v-deep .steps-done .is-wait .el-step__title,
  ::v-deep .steps-done .is-wait .el-step__description {
    color: #3370FF !important;
  }

  ::v-deep .steps-done .el-step__line-inner {
    border-color: #3370FF !important;
  }

	.file-table {
		text-align: center;

		.table {
			border: 1px solid rgba(221, 221, 221, 0.56);
			border-radius: 8px;
			width: 90%;
			border-collapse: collapse;
			margin-left: 5%;
			padding: 0 8px;

			thead:nth-of-type(1) {
				td {
					font-size: 14px;
					font-family: PingFangSC, PingFang SC;
					font-weight: 400;
					color: #777777;
					background: rgba(221, 221, 221, 0.24);
					width: 200px;
				}
			}

			tr {
				height: 40px;

				td {
					padding-left: 8px;
					font-size: 14px;
					font-family: PingFangSC, PingFang SC;
					font-weight: 400;
					color: #333333;
					width: 200px;

					.division-line {
						display: inline-block;
						height: 20px;
						width: 100%;
						border-right: 1px solid #DDDDDD;
					}

					.blue {
						color: #027FFC;
						cursor: pointer;
					}
				}
			}
		}
	}

	::v-deep .dialog {
		width: 1132px;
		height: 600px;

		.dialog__header {
			text-align: left;
		}

		.dialog__body {
			padding: 0px;
		}

		.el-form-item--medium {
			width: 47%;
			margin-bottom: 0px
		}

		.commodities {
			height: auto;

			.main-info {
				padding: 0px;
			}
		}
	}

	.record-title {
		text-align: left;
		padding: 10px;
		font-size: 14px;
		margin-top: 10px;
		margin-bottom: 10px;
	}
	.red{
		color: #FF5E5E;
	}
	.green{
		color: #13ce66;
	}

	table tbody {
		display: block;
		height: 395px;
		overflow-y: scroll;
	}

	table thead,
	tbody tr {
		display: table;
		table-layout: fixed;/*重要  表格固定算法*/
	}
</style>
